import React from 'react'
import { Modal } from 'asterX-UI/Modals'
import ModalTitle from 'asterX-UI/Modals/ModalTitle'
import React360Viewer from 'asterX-UI/React360view/React360Viewer'

const Car360View = ({ vin, onClose }) => {
  return (
    <Modal open={true} onClose={onClose} fullScreen>
      <ModalTitle onClose={onClose}>360 View</ModalTitle>
      <div
        style={{
          position: 'relative'
        }}
      >
        <React360Viewer
          amount={115}
          imagePath={`https://360.aster.kz/360ex_dc/${vin}/`}
          fileName={`image{index}.webp`}
        />
      </div>
    </Modal>
  )
}
export default Car360View
